import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';
import R from 'ramda';

import LoginSection from '_templates/LoginSection';

export default function LoginPage() {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    if (auth.isAuthenticated) {
      dispatch(push('/'));
    }
  }, []);

  return (
    <div className="login-page page">
      <LoginSection />
    </div>
  );
}
